import { useState, useEffect } from "react";
import styles from "./myprofile.module.css";
import withCustomerAuth from "../../components/withCustomerAuth";
import { authData } from "../../../admin/components/GetAuth";
import { Link as RouterLink } from "react-router-dom";
import dayjs from "dayjs";
import SideBar from "../../components/sideBar";
import CopyToClipboard from "react-copy-to-clipboard";
import { Tooltip } from "@mui/material";
import { Copy } from "react-feather";

function MyProfile() {
  const auth = authData();
  const [customerLink, setCustomerLink] = useState("");

  useEffect(() => {
    if (authData()?.company?.urltoken && authData()?.customer?.reference_token) {
      setCustomerLink(process.env.REACT_APP_BASE_URL + '/customer-sign-up/' + authData()?.customer?.reference_token + '/' + authData()?.company?.urltoken);
    }
  }, []);

  return (<div className={`${styles.MainDivCustomer}`}>
    <div className={`${styles.Container}`}>
      <div className={`${styles.CusRow}`}>
        <div className={`${styles.CustomerSideBar}`}><SideBar /></div>
        <div className={`${styles.CustomerDeSec}`}>
          <div className={`${styles.UserProCard2}`}>
            <div className={`${styles.UserHead}`}>
              <p className={`${styles.UserProName}`}>{auth?.customer?.name}</p>
              <RouterLink className={`${styles.SideEditBU} ${styles.SideEditBU2}`} to={"/customer/update-profile"}>Edit Profile</RouterLink>
              <RouterLink className={`${styles.SideEditBU} ${styles.SideEditBU3}`} to={"/customer/change-password"}>Change Password</RouterLink>
            </div>
            <div className={`${styles.UserProDe}`}>
              <p className={`${styles.UserProDeList}`}>
                <span>Customer Id:</span> {auth?.customer?.customer_id}
              </p>
              <p className={`${styles.UserProDeList}`}>
                <span>Name:</span> {auth?.customer?.name}
              </p>
              <p className={`${styles.UserProDeList}`}>
                <span>Email:</span> {auth?.customer?.email}
              </p>
              <p className={`${styles.UserProDeList}`}>
                <span>Phone No:</span> {auth?.customer?.phone}
              </p>
              <p className={`${styles.UserProDeList}`}>
                <span>Date Of Birth:</span> {dayjs(auth?.customer?.dob).format("DD/MM/YYYY")}
              </p>
              <p className={`${styles.UserProDeList}`}>
                <span>Address:</span> {auth?.customer?.address}
              </p>
              <p className={`${styles.UserProDeList}`}>
                <span>Post Code:</span> {auth?.customer?.post_code}
              </p>
              <p className={`${styles.UserProDeList} ${styles.UserProDeList2}`}>
                <span>Do you have a Registered Company?:</span> {auth?.customer?.registered_company}
              </p>
              {auth?.customer?.registered_company === "Yes" && (<>
                <p className={`${styles.UserProDeList} ${styles.UserProDeList2}`}>
                  <span>Are you shipping the goods in the name of the company?: </span> {auth?.customer?.company_shipping}
                </p>
                <p className={`${styles.UserProDeList} ${styles.UserProDeList2}`}>
                  <span>Registered Company Name:</span>{auth?.customer?.company_name}
                </p>
              </>)}
              <p className={`${styles.UserProDeList} ${styles.UserProDeList2}`}>
                <span>Reference Link:</span>
                <CopyToClipboard text={customerLink}>
                  <Tooltip title={"Click to copy"}>
                    <span style={{ width: '400px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '15px', fontWeight: 600, lineHeight: '22px', color: '#ef233c', cursor: 'pointer' }}>{customerLink}</span>
                  </Tooltip>
                </CopyToClipboard>
                <CopyToClipboard text={customerLink}>
                  <Tooltip title={"Click to copy"}>
                    <Copy style={{ width: '18px', cursor: 'pointer' }} />
                  </Tooltip>
                </CopyToClipboard>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>);
}

export default withCustomerAuth(MyProfile);